/**
 * Mock Data for Tool Display Demo
 *
 * Provides sample data for each tool in different states (success, error, empty).
 */ // File Tools
export const listFilesMock = {
    toolId: 'list-files',
    states: {
        loading: {
            input: {
                directory: '/projects/rfp-analysis'
            }
        },
        success: {
            output: {
                files: [
                    {
                        name: 'RFP-2024-001.pdf',
                        type: 'pdf',
                        size: 2450000
                    },
                    {
                        name: 'attachment-a.docx',
                        type: 'docx',
                        size: 156000
                    },
                    {
                        name: 'pricing-matrix.xlsx',
                        type: 'xlsx',
                        size: 89000
                    },
                    {
                        name: 'SOW-draft.pdf',
                        type: 'pdf',
                        size: 1230000
                    }
                ],
                directory: '/projects/rfp-analysis',
                totalCount: 4
            },
            input: {
                directory: '/projects/rfp-analysis'
            },
            duration: 234
        },
        empty: {
            output: {
                files: [],
                directory: '/projects/empty-folder',
                totalCount: 0
            },
            input: {
                directory: '/projects/empty-folder'
            },
            duration: 156
        },
        error: {
            output: {
                error: 'Directory not found: /projects/invalid-path'
            },
            input: {
                directory: '/projects/invalid-path'
            },
            duration: 89
        },
        pending: {
            // A completed run that returned nothing — the classifier reads a null
            // output as 'pending', not 'empty'.
            output: null,
            input: {
                directory: '/projects/rfp-analysis'
            }
        }
    }
};
export const readFileMock = {
    toolId: 'read-file',
    states: {
        loading: {
            input: {
                filePath: '/projects/rfp-analysis/RFP-2024-001.pdf'
            }
        },
        success: {
            output: {
                content: 'REQUEST FOR PROPOSAL\n\nSolicitation Number: RFP-2024-001\nTitle: Cybersecurity Assessment Services\n\nThe Department of Defense seeks qualified contractors to provide comprehensive cybersecurity assessment services...',
                fileName: 'RFP-2024-001.pdf',
                size: 2450000,
                contentType: 'application/pdf'
            },
            input: {
                filePath: '/projects/rfp-analysis/RFP-2024-001.pdf'
            },
            duration: 1245
        },
        error: {
            output: {
                error: 'Failed to read file: Permission denied'
            },
            input: {
                filePath: '/projects/restricted/secret.pdf'
            },
            duration: 45
        }
    }
};
// GovCon Tools
export const rfpShredderMock = {
    toolId: 'rfp-shredder',
    states: {
        loading: {
            input: {
                documentId: 'doc-rfp-001'
            }
        },
        success: {
            output: {
                sections: [
                    {
                        title: 'Overview',
                        pageStart: 1,
                        pageEnd: 5
                    },
                    {
                        title: 'Technical Requirements',
                        pageStart: 6,
                        pageEnd: 25
                    },
                    {
                        title: 'Evaluation Criteria',
                        pageStart: 26,
                        pageEnd: 32
                    },
                    {
                        title: 'Pricing Instructions',
                        pageStart: 33,
                        pageEnd: 40
                    }
                ],
                totalPages: 40,
                extractedRequirements: 47
            },
            input: {
                documentId: 'doc-rfp-001'
            },
            duration: 8934
        },
        error: {
            output: {
                error: 'Failed to parse document: Unsupported file format'
            },
            input: {
                documentId: 'doc-invalid'
            },
            duration: 234
        }
    }
};
export const bidNoBidMock = {
    toolId: 'bid-no-bid-scorer',
    states: {
        loading: {
            input: {
                opportunityId: 'sam-opp-123'
            }
        },
        success: {
            output: {
                recommendation: 'BID',
                score: 78,
                factors: [
                    {
                        name: 'Past Performance',
                        score: 85,
                        weight: 0.3
                    },
                    {
                        name: 'Technical Capability',
                        score: 75,
                        weight: 0.35
                    },
                    {
                        name: 'Price Competitiveness',
                        score: 70,
                        weight: 0.2
                    },
                    {
                        name: 'Teaming Opportunities',
                        score: 80,
                        weight: 0.15
                    }
                ],
                risks: [
                    'Tight timeline',
                    'Requires CMMC Level 3'
                ]
            },
            input: {
                opportunityId: 'sam-opp-123'
            },
            duration: 4567
        },
        error: {
            output: {
                error: 'Opportunity not found in SAM.gov'
            },
            input: {
                opportunityId: 'invalid-opp'
            },
            duration: 1234
        }
    }
};
export const samOpportunitySearchMock = {
    toolId: 'sam-opportunity-search',
    states: {
        loading: {
            input: {
                keywords: 'cybersecurity',
                naicsCode: '541512'
            }
        },
        success: {
            output: {
                opportunities: [
                    {
                        id: 'opp-001',
                        title: 'Cybersecurity Assessment Services',
                        agency: 'Department of Defense',
                        postedDate: '2024-01-15',
                        responseDeadline: '2024-02-15',
                        setAside: '8(a)'
                    },
                    {
                        id: 'opp-002',
                        title: 'Network Security Monitoring',
                        agency: 'Department of Homeland Security',
                        postedDate: '2024-01-10',
                        responseDeadline: '2024-02-10',
                        setAside: 'Small Business'
                    }
                ],
                totalCount: 12,
                hasMore: true
            },
            input: {
                keywords: 'cybersecurity',
                naicsCode: '541512'
            },
            duration: 2345
        },
        empty: {
            output: {
                opportunities: [],
                totalCount: 0,
                hasMore: false
            },
            input: {
                keywords: 'quantum computing submarine',
                naicsCode: '999999'
            },
            duration: 1890
        },
        error: {
            output: {
                error: 'SAM.gov API rate limit exceeded. Please try again in 60 seconds.'
            },
            input: {
                keywords: 'test'
            },
            duration: 234
        }
    }
};
export const generatePmpMock = {
    toolId: 'generate-pmp',
    states: {
        loading: {
            input: {
                projectName: 'Cloud Migration Project'
            }
        },
        success: {
            output: {
                documentId: 'pmp-doc-456',
                title: 'Project Management Plan - Cloud Migration Project',
                sections: [
                    'Scope',
                    'Schedule',
                    'Budget',
                    'Risk Management',
                    'Quality'
                ],
                generatedAt: new Date().toISOString()
            },
            input: {
                projectName: 'Cloud Migration Project',
                template: 'standard'
            },
            duration: 12345
        },
        error: {
            output: {
                error: 'Failed to generate PMP: Missing required project parameters'
            },
            input: {
                projectName: ''
            },
            duration: 567
        }
    }
};
export const analyzeLcatMock = {
    toolId: 'analyze-lcat',
    states: {
        loading: {
            input: {
                resumeId: 'resume-789'
            },
            progressState: {
                currentStep: 'extract',
                status: 'processing',
                progress: 35,
                details: 'Extracting skills and experience...'
            }
        },
        success: {
            output: {
                matchedLcats: [
                    {
                        code: 'Software Developer III',
                        confidence: 92
                    },
                    {
                        code: 'Systems Engineer II',
                        confidence: 78
                    },
                    {
                        code: 'Data Scientist II',
                        confidence: 65
                    }
                ],
                skills: [
                    'Python',
                    'AWS',
                    'Machine Learning',
                    'Kubernetes'
                ],
                yearsExperience: 8
            },
            input: {
                resumeId: 'resume-789'
            },
            duration: 5678
        },
        error: {
            output: {
                error: 'Failed to analyze resume: Document is encrypted'
            },
            input: {
                resumeId: 'encrypted-resume'
            },
            duration: 890
        }
    }
};
// GSA Tools
export const gsaPricingMock = {
    toolId: 'gsa-pricing',
    states: {
        loading: {
            input: {
                laborCategory: 'Software Developer',
                sin: '54151S'
            }
        },
        success: {
            output: {
                laborCategory: 'Software Developer III',
                sin: '54151S',
                rates: [
                    {
                        year: 2024,
                        hourlyRate: 145.5,
                        ceiling: 175.0
                    },
                    {
                        year: 2025,
                        hourlyRate: 150.25,
                        ceiling: 180.5
                    }
                ],
                contractNumber: 'GS-35F-0001X',
                vendor: 'Acme Consulting'
            },
            input: {
                laborCategory: 'Software Developer',
                sin: '54151S'
            },
            duration: 1234
        },
        empty: {
            output: {
                laborCategory: 'Quantum Engineer',
                sin: '54151S',
                rates: [],
                message: 'No pricing data found for this labor category'
            },
            input: {
                laborCategory: 'Quantum Engineer',
                sin: '54151S'
            },
            duration: 890
        },
        error: {
            output: {
                error: 'Invalid SIN code provided'
            },
            input: {
                laborCategory: 'Developer',
                sin: 'INVALID'
            },
            duration: 234
        }
    }
};
// Corporate Tools
export const corporateFamilyTreeMock = {
    toolId: 'corporate-family-tree',
    states: {
        loading: {
            input: {
                companyName: 'Acme Corporation'
            },
            progressState: {
                currentStep: 'sec-edgar',
                status: 'processing',
                progress: 60,
                details: 'Searching SEC EDGAR filings...'
            }
        },
        success: {
            output: {
                company: {
                    name: 'Acme Corporation',
                    duns: '123456789',
                    uei: 'ABC123DEF456'
                },
                parent: {
                    name: 'Acme Holdings Inc.',
                    duns: '987654321'
                },
                subsidiaries: [
                    {
                        name: 'Acme Tech Solutions',
                        duns: '111222333'
                    },
                    {
                        name: 'Acme Federal Services',
                        duns: '444555666'
                    }
                ],
                affiliates: [
                    {
                        name: 'Acme International',
                        relationship: 'Sister Company'
                    }
                ],
                sources: [
                    'SAM.gov',
                    'SEC EDGAR',
                    'OpenCorporates'
                ]
            },
            input: {
                companyName: 'Acme Corporation'
            },
            duration: 23456
        },
        error: {
            output: {
                error: 'Company not found in any data source'
            },
            input: {
                companyName: 'Nonexistent Corp LLC'
            },
            duration: 15678
        }
    }
};
// Classifier Tools
export const naicsClassificationMock = {
    toolId: 'naics-classification',
    states: {
        loading: {
            input: {
                description: 'Software development and cloud services'
            }
        },
        success: {
            output: {
                classifications: [
                    {
                        code: '541512',
                        title: 'Computer Systems Design Services',
                        confidence: 95
                    },
                    {
                        code: '541511',
                        title: 'Custom Computer Programming Services',
                        confidence: 82
                    },
                    {
                        code: '518210',
                        title: 'Data Processing and Hosting Services',
                        confidence: 68
                    }
                ],
                primaryRecommendation: '541512'
            },
            input: {
                description: 'Software development and cloud services'
            },
            duration: 1567
        },
        error: {
            output: {
                error: 'Description too short for accurate classification'
            },
            input: {
                description: 'IT'
            },
            duration: 234
        }
    }
};
// E2B Tools
export const executePythonMock = {
    toolId: 'execute-python',
    states: {
        loading: {
            input: {
                code: 'import pandas as pd\ndf = pd.read_csv("data.csv")'
            }
        },
        success: {
            output: {
                stdout: 'Analysis complete. Found 1,234 records.\nMean value: 45.67\nStandard deviation: 12.34',
                stderr: '',
                executionTime: 2.34,
                artifacts: [
                    {
                        type: 'image',
                        name: 'chart.png'
                    }
                ]
            },
            input: {
                code: 'import pandas as pd\ndf = pd.read_csv("data.csv")\nprint(df.describe())'
            },
            duration: 5678
        },
        error: {
            output: {
                stdout: '',
                stderr: "ModuleNotFoundError: No module named 'nonexistent_package'",
                executionTime: 0.12
            },
            input: {
                code: 'import nonexistent_package'
            },
            duration: 890
        }
    }
};
// Web Search Tools
export const linkupSearchMock = {
    toolId: 'linkup-search',
    states: {
        loading: {
            input: {
                query: 'federal cybersecurity regulations 2024',
                depth: 'deep'
            }
        },
        success: {
            output: {
                success: true,
                data: {
                    provider: 'linkup',
                    answer: 'The Federal Information Security Management Act (FISMA) requires federal agencies to develop, document, and implement information security programs. Recent updates in 2024 include enhanced requirements for zero trust architecture and supply chain security. The Cybersecurity and Infrastructure Security Agency (CISA) has issued new binding operational directives requiring agencies to implement endpoint detection and response capabilities.',
                    sources: [
                        {
                            title: 'CISA Cybersecurity Directives',
                            url: 'https://cisa.gov/directives',
                            snippet: 'Binding operational directives for federal agencies...'
                        },
                        {
                            title: 'FISMA Overview',
                            url: 'https://csrc.nist.gov/topics/laws-and-regulations/fisma',
                            snippet: 'Federal Information Security Modernization Act...'
                        },
                        {
                            title: 'OMB Zero Trust Memo',
                            url: 'https://whitehouse.gov/omb/zero-trust',
                            snippet: 'Moving toward zero trust cybersecurity principles...'
                        }
                    ]
                }
            },
            input: {
                query: 'federal cybersecurity regulations 2024',
                depth: 'deep'
            },
            duration: 4567
        },
        empty: {
            output: {
                success: true,
                data: {
                    provider: 'linkup',
                    answer: 'No relevant information found for this query.',
                    sources: []
                }
            },
            input: {
                query: 'xyz123abc nonexistent topic',
                depth: 'standard'
            },
            duration: 2345
        },
        error: {
            output: {
                success: false,
                error: {
                    code: 'RATE_LIMITED',
                    severity: 'warning',
                    message: 'API rate limit exceeded. Please wait before making more requests.',
                    recoveryHints: [
                        'Wait 60 seconds before retrying',
                        'Consider using cached results'
                    ]
                },
                message: 'Search failed due to rate limiting'
            },
            input: {
                query: 'test query'
            },
            duration: 234
        }
    }
};
export const exaSearchMock = {
    toolId: 'exa-search',
    states: {
        loading: {
            input: {
                query: 'government contract opportunities IT services'
            }
        },
        success: {
            output: {
                success: true,
                data: {
                    provider: 'exa',
                    answer: 'Government IT services contracting is projected to grow significantly in FY2024, with major opportunities in cloud migration, cybersecurity, and AI/ML implementations. Key agencies with active procurement include DoD, VA, and DHS. The GSA STARS III and CIO-SP4 vehicles are primary contract vehicles for IT services acquisition.',
                    citations: [
                        {
                            title: 'Federal IT Spending Forecast',
                            url: 'https://deltek.com/federal-it',
                            snippet: 'Federal IT spending projected to reach...'
                        },
                        {
                            title: 'GSA IT Schedule 70',
                            url: 'https://gsa.gov/schedule70',
                            snippet: 'IT professional services and solutions...'
                        }
                    ]
                }
            },
            input: {
                query: 'government contract opportunities IT services'
            },
            duration: 3456
        },
        error: {
            output: {
                success: false,
                error: {
                    code: 'SERVICE_UNAVAILABLE',
                    severity: 'error',
                    message: 'Exa search service is temporarily unavailable',
                    recoveryHints: [
                        'Try again in a few minutes',
                        'Use alternative search provider'
                    ]
                },
                message: 'Exa search service unavailable'
            },
            input: {
                query: 'test'
            },
            duration: 5000
        }
    }
};
export const samOpportunityScraperMock = {
    toolId: 'sam-opportunity-scraper',
    states: {
        loading: {
            input: {
                opportunityId: 'sam-notice-12345',
                saveToWorkspace: true
            },
            progressState: {
                currentStep: 'embed',
                status: 'processing',
                progress: 65,
                details: 'Generating embeddings for semantic search...'
            }
        },
        success: {
            output: {
                success: true,
                opportunity: {
                    noticeId: 'sam-notice-12345',
                    title: 'Enterprise Cloud Migration Services',
                    agency: 'Department of Veterans Affairs',
                    type: 'Presolicitation',
                    postedDate: '2024-01-20',
                    responseDeadline: '2024-03-01',
                    naicsCode: '541512',
                    setAside: 'Service-Disabled Veteran-Owned Small Business'
                },
                savedToWorkspace: true,
                embeddingsGenerated: true,
                matchingProfiles: [
                    {
                        profileName: 'Cloud Services Profile',
                        matchScore: 87
                    },
                    {
                        profileName: 'VA Past Performance',
                        matchScore: 72
                    }
                ]
            },
            input: {
                opportunityId: 'sam-notice-12345',
                saveToWorkspace: true
            },
            duration: 18234
        },
        empty: {
            output: {
                success: true,
                opportunity: null,
                message: 'Opportunity not found or has been archived'
            },
            input: {
                opportunityId: 'archived-notice-old'
            },
            duration: 3456
        },
        error: {
            output: {
                success: false,
                error: {
                    code: 'SAM_API_ERROR',
                    severity: 'error',
                    message: 'Failed to fetch opportunity from SAM.gov. The notice may have been removed.',
                    recoveryHints: [
                        'Verify the notice ID is correct',
                        'Check if the notice is still active on SAM.gov'
                    ]
                },
                message: 'SAM.gov API error'
            },
            input: {
                opportunityId: 'invalid-id'
            },
            duration: 5678
        }
    }
};
// Export all mocks as a map
export const allToolMocks = {
    'list-files': listFilesMock,
    'read-file': readFileMock,
    'rfp-shredder': rfpShredderMock,
    'bid-no-bid-scorer': bidNoBidMock,
    'sam-opportunity-search': samOpportunitySearchMock,
    'generate-pmp': generatePmpMock,
    'analyze-lcat': analyzeLcatMock,
    'gsa-pricing': gsaPricingMock,
    'corporate-family-tree': corporateFamilyTreeMock,
    'naics-classification': naicsClassificationMock,
    'execute-python': executePythonMock,
    'linkup-search': linkupSearchMock,
    'exa-search': exaSearchMock,
    'sam-opportunity-scraper': samOpportunityScraperMock
};
export function getToolMock(toolId) {
    return allToolMocks[toolId];
}
